import {
  Button,
  Center,
  Heading,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Text,
} from "@chakra-ui/react";
import { useDynamicModalContext } from "@umami/components";

interface OperationSubmittedModalProps {
  onSeeAllOperations: () => void;
}

export const OperationSubmittedModal = ({ onSeeAllOperations }: OperationSubmittedModalProps) => {
  const { onClose } = useDynamicModalContext();

  return (
    <ModalContent>
      <ModalHeader>
        <ModalCloseButton />
        <Center flexDirection="column" gap="12px">
          <Heading size="xl">Operation Submitted</Heading>
        </Center>
      </ModalHeader>
      <ModalBody>
        <Text>
          You can follow this operation's progress in the Activity section. It may take up to 30
          seconds to appear.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button
          width="full"
          onClick={() => {
            onSeeAllOperations();
            onClose();
          }}
          variant="primary"
        >
          See All Operations
        </Button>
      </ModalFooter>
    </ModalContent>
  );
};
